module.exports = {
      id: "icon-transportation-usage",
      viewBox: "0 0 57 38",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-transportation",
      toString: function () {
        return this.url;
      }
    }